import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";
import { DEVTOOLS_ENABLED } from "../../consts";
import { THomeTab } from "./homeTabs";

interface HomeTabState {
  /** The selected home tab. */
  homeTab: THomeTab;
  setHomeTab: (homeTab: THomeTab) => void;
}

// Replaces the `homeTabSignal` preact signal.
//
// `create` comes from "zustand" directly, NOT feat/appState/resetState: that wrapper
// registers stores for `resetAllStores()` on logout, and the signal was never reset.
// Module-level lifetime is deliberate — the selected tab survives remounts of the home
// route, including the separate portaled AppRoutes instances under native navigation.
export const useHomeTabStore = create<HomeTabState>()(
  subscribeWithSelector(
    devtools(
      (set) => ({
        homeTab: "itinerary",
        setHomeTab: (homeTab) => set({ homeTab }, false, "setHomeTab"),
      }),
      { enabled: DEVTOOLS_ENABLED, name: "homeTab" },
    ),
  ),
);

export const useHomeTab = () => useHomeTabStore((s) => s.homeTab);
